import React from "react";

export default function CommentsEditor({ comments = {}, onChange }) {
  const set = (key, value) => onChange({ ...comments, [key]: value });
  const email = (comments.notify_email || "").trim();
  const incompleteEmail = email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);

  return (
    <fieldset style={{ marginBottom: 24 }}>
      <legend><strong>Commentaires des lecteurs</strong></legend>
      <label>
        <input
          type="checkbox"
          checked={Boolean(comments.enabled)}
          onChange={(event) => set("enabled", event.target.checked)}
        />{" "}
        Afficher les commentaires des lecteurs sur le site
      </label>
      <label style={{ display: "block", marginTop: 12 }}>
        Prévenir de chaque nouveau commentaire à l'adresse
        <input
          type="email"
          value={comments.notify_email || ""}
          onChange={(event) => set("notify_email", event.target.value)}
          style={{ width: "100%", padding: 8, margin: "4px 0 8px" }}
        />
      </label>
      {incompleteEmail && (
        <p style={{ fontSize: 12, color: "#8a5200", margin: "0 0 8px" }}>
          Adresse incomplète : aucun e-mail ne partira.
        </p>
      )}
      <p style={{ fontSize: 12, color: "#666", margin: 0 }}>
        Les lecteurs laissent un prénom et un message, publiés tout de suite. Chaque commentaire arrive par e-mail avec un lien pour le masquer. Pris en compte à la prochaine publication.
      </p>
    </fieldset>
  );
}
